import { Box } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { dawLogos } from '@/theme';
import { ActionButton, DawTile } from '@/common/components/ui';
import { useGoogleSignIn } from '@/common/auth/components/GoogleSignIn';
import { WORKS_WITH } from './content';
import { LandingProductDemo } from './LandingProductDemo';

export function LandingHero({ onDownload }: { onDownload: () => void }) {
  const { signIn, isLoading, isConfigured } = useGoogleSignIn();
  return (
    <section className="lp-hero">
      <div className="lp-hero-layout">
        <div className="lp-hero-copy">
          <p className="lp-hero-kicker">A WORKSPACE FOR MUSIC IN THE MAKING</p>
          <h1>
            Make room <br />
            for your <br />
            <span>next version.</span>
          </h1>
          <p className="lp-hero-description">
            Your sessions, their history, and the people who bring them to life.
            Together in StudioVault.
          </p>
          <div className="lp-hero-actions">
            {isConfigured && (
              <ActionButton
                className="lp-gloss-action"
                size="xl"
                onClick={signIn}
                disabled={isLoading}
                sx={{ borderRadius: '7px', px: 2.5, py: 1.4 }}
              >
                {isLoading ? 'Signing in…' : 'Get started with Google'}
                <ArrowForward sx={{ fontSize: 16 }} />
              </ActionButton>
            )}
            <button className="lp-hero-download" onClick={onDownload}>
              Download the desktop app <ArrowForward sx={{ fontSize: 15 }} />
            </button>
          </div>
          <p className="lp-hero-beta">
            Currently in beta. <br />
            Desktop app required for local sync.
          </p>
        </div>
        <LandingProductDemo />
      </div>
      <div className="lp-daw-strip">
        <span>YOUR DAW. YOUR WAY OF WORKING.</span>
        <div>
          {WORKS_WITH.map(([key, label]) => (
            <Box
              key={key}
              sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}
            >
              <DawTile src={dawLogos[key]} label={label} size={21} radius={5} />
              <span>{label}</span>
            </Box>
          ))}
        </div>
      </div>
    </section>
  );
}
export default LandingHero;
